export const appInfo = {
  appName: 'SWIM Client Portal',
} as const;
